import { render, staticRenderFns } from "./PriceManagement.vue?vue&type=template&id=afa6b45c&scoped=true"
import script from "./PriceManagement.vue?vue&type=script&lang=js"
export * from "./PriceManagement.vue?vue&type=script&lang=js"
import style0 from "./PriceManagement.vue?vue&type=style&index=0&id=afa6b45c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa6b45c",
  null
  
)

export default component.exports